import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import { Row } from 'hedron';
import { connect } from 'react-redux';
import { onSaleParam, sortOptionPVInsertTime } from '../../../helpers/helpers';
import TrackingEvents from '../../../common/models/TrackingEvents';
import Departments from '../../../common/models/Departments';
import DepartmentBox from '../../DepartmentBox/DepartmentBox';
import NavigationLevel from './NavigationLevel';
import NewInSaleNavigation from './NewInSaleNavigation';
import ActionLinks from '../../Header/ActionLinks/ActionLinks';
import withCountryCode from '../../RoutesHoc/RoutesHoc';
import { trackAction } from '../../../common/actions/trackingActions';

const mapStateToProps = ({ api: { menu, path, s3BasePath } }) => ({
  menu,
  path,
  s3BasePath,
});

const mapDispatchToProps = dispatch => ({
  track: (eventType, payload) => dispatch(trackAction(eventType, payload)),
});

const newInQuery = `?min_price=&max_price=&sort_field=${sortOptionPVInsertTime}&q=&limit=60&skip=0`;
const saleQuery = `?${onSaleParam}`;

class NavigationMenuMobile extends React.Component {
  constructor(props) {
    super(props);
    this.resetNavigationLevel = this.resetNavigationLevel.bind(this);
    this.handleLevel = this.handleLevel.bind(this);
    this.handleBack = this.handleBack.bind(this);

    this.state = {
      newInParams: newInQuery,
      saleParams: saleQuery,
      level: 0,
      level0data: props.menu.find(el => el.name.toLowerCase() === Departments.getInternalName(props.department)),
      applySale: false,
      applyNewIn: false,
    };
  }

  componentDidUpdate(prevProps) {
    const { department, isOpen } = this.props;
    if (prevProps.department !== department) {
      this.resetNavigationLevel();
    }

    if (isOpen && isOpen !== prevProps.isOpen) {
      this.setState({ resetDepartment: false });
    }
  }

  resetNavigationLevel() {
    const { menu, department } = this.props;
    const newState = {
      newInParams: newInQuery,
      saleParams: saleQuery,
      level: 0,
      level0data: menu.find(el => el.name.toLowerCase() === Departments.getInternalName(department)),
      applySale: false,
      applyNewIn: false,
    };
    this.setState(newState);
  }

  handleLevel(curr, { allCategoryClick = false, name = '', applyQueryParams = null } = {}) {
    const { department, buildUrlWithCountry, track } = this.props;
    const { level, applyNewIn, applySale, saleParams, newInParams } = this.state;
    if (curr.name.toLowerCase() === 'designers') {
      const payload = {
        categoryDepartment: {
          department: department.toLowerCase(),
          category: 'Designers',
          subcategory: '',
        },
      };
      track(TrackingEvents.categorySelected(), payload);
      window.location = buildUrlWithCountry(curr.url);
    }

    const data = {
      ...curr,
    };

    let queryParams = '';
    if (applySale || applyNewIn) {
      queryParams = applySale ? saleParams : newInParams;
      data.name = applySale ? `Sale ${data.name}` : `New In ${data.name}`;
    }

    if (allCategoryClick || (curr.children && curr.children.length === 0)) {
      const category = this.state[`level${level}data`].name;
      const subcategory = allCategoryClick ? `All ${curr.name}` : curr.name;
      const payload = { categoryDepartment: { department: department.toLowerCase(), category, subcategory } };
      track(TrackingEvents.categorySelected(), payload);
      window.location = buildUrlWithCountry(`${curr.url}/${queryParams}`);
      return;
    }

    if (applyQueryParams) {
      data.name = name;
      data.children = data.children.filter(el => el.name.toLowerCase() !== 'designers');
    }

    const newState = {
      level: level + 1,
      [`level${level + 1}data`]: data,
    };
    if (applyQueryParams) {
      newState[applyQueryParams] = true;
    }

    this.setState({ ...newState });
  }

  handleBack() {
    const { level, applyNewIn, applySale } = this.state;
    const newLevel = level - 1;
    this.setState({
      level: newLevel,
      applyNewIn: newLevel === 0 ? false : applyNewIn,
      applySale: newLevel === 0 ? false : applySale,
      [`level${level}data`]: null,
    });
  }

  render() {
    const { isOpen, toggle, s3BasePath, initialDepartment, handleClickDepartment, department } = this.props;
    const { level, resetDepartment } = this.state;

    return (
      <Modal
        className="navigationMenu"
        closeTimeoutMS={800}
        contentLabel="Navigation Menu"
        isOpen={isOpen}
        onRequestClose={() => {
          this.resetNavigationLevel();
          this.setState({ resetDepartment: true });
          toggle();
        }}
        overlayClassName="navigationMenuOverlay"
        shouldCloseOnOverlayClick
        ariaHideApp={false}
      >
        <Row justifyContent="space-around" style={{ margin: '20px 0' }}>
          <DepartmentBox
            context="nav"
            resetDepartment={resetDepartment}
            initialDepartment={initialDepartment}
            department={department}
            handleClick={(selectedDepartment, e) => handleClickDepartment(selectedDepartment, e)}
            underline
          />
        </Row>

        <NavigationLevel
          handleLevel={this.handleLevel}
          level={level}
          values={this.state[`level${level}data`]}
          s3BasePath={s3BasePath}
          handleBack={this.handleBack}
        >
          {level === 0 && (
            <NewInSaleNavigation
              s3BasePath={s3BasePath}
              handleClick={this.handleLevel}
              values={this.state.level0data}
            />
          )}
        </NavigationLevel>
        <Row justifyContent="center" style={{ marginTop: '80px' }}>
          <ActionLinks />
        </Row>
      </Modal>
    );
  }
}

NavigationMenuMobile.propTypes = {
  menu: PropTypes.arrayOf(
    PropTypes.shape({
      children: PropTypes.array,
      name: PropTypes.string,
      url: PropTypes.string,
    }),
  ),
  isOpen: PropTypes.bool.isRequired,
  department: PropTypes.string.isRequired,
  s3BasePath: PropTypes.string.isRequired,
  toggle: PropTypes.func.isRequired,
  track: PropTypes.func.isRequired,
};

NavigationMenuMobile = connect(mapStateToProps, mapDispatchToProps)(NavigationMenuMobile);

export default withCountryCode(NavigationMenuMobile);
